import { render, staticRenderFns } from "./RicLogs.vue?vue&type=template&id=26d354bb"
import script from "./RicLogs.vue?vue&type=script&lang=js"
export * from "./RicLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports